import { render, staticRenderFns } from "./InputSearch.vue?vue&type=template&id=16be3f7b&scoped=true&lang=pug"
import script from "./InputSearch.vue?vue&type=script&lang=js"
export * from "./InputSearch.vue?vue&type=script&lang=js"
import style0 from "./InputSearch.vue?vue&type=style&index=0&id=16be3f7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be3f7b",
  null
  
)

export default component.exports